class ProductVariantsToggle {
  constructor() {
    this.initialized = false;
    this.clickHandler = null;
    this.hoverHandler = null;
    this.init();
  }

  init() {
    if (this.initialized) {
      return;
    }

    this.clickHandler = (e) => {
      const toggleButton = e.target.closest('[data-variants-toggle]');

      if (toggleButton) {
        e.preventDefault();
        this.removePreload();
        toggleButton.classList.add('pre-loading');
        this.handleToggle(toggleButton);
        return;
      }

      const variantButton = e.target.closest('[data-variant-submit]');
      if (variantButton) {
        this.handleVariantSelect(variantButton);
        return;
      }

      if (!e.target.closest('.product-variants-wrapper')) {
        this.closeAllVariants();
        this.removePreload();
      }
    };

    document.addEventListener('click', this.clickHandler);
    this.setupHoverListeners();
    this.initialized = true;
  }

  destroy() {
    if (this.clickHandler) {
      document.removeEventListener('click', this.clickHandler);
      this.clickHandler = null;
    }
    if (this.hoverHandler) {
      document.body.removeEventListener('mouseover', this.hoverHandler);
      this.hoverHandler = null;
    }
    this.initialized = false;
  }

  removePreload() {
    document.querySelectorAll('[data-variants-toggle]').forEach(loader => {
      loader.classList.remove('pre-loading');
    });
  }

  setupHoverListeners() {
    this.hoverHandler = (e) => {
      if (!e.target || !e.target.closest) return;

      const variantButton = e.target.closest('[data-variant-submit]');
      if (variantButton && variantButton.closest('.variants-list-inline')) {
        this.handleVariantHover(variantButton);
      }
    };

    document.body.addEventListener('mouseover', this.hoverHandler);
  }

  handleVariantHover(button) {
    const wrapper = button.closest('.product-variants-wrapper');
    const variantsList = button.closest('[data-variants-list]');

    wrapper.querySelectorAll('[data-variant-submit]').forEach(btn => {
      btn.classList.remove('hover-active');
    });

    button.classList.add('hover-active');

    const variantsData = this.getVariantsData(variantsList);
    if (!variantsData) return;

    const currentVariantId = button.dataset.variantId;
    const variantInfo = variantsData.find(v => v.id == currentVariantId);

    if (variantInfo && variantInfo.featured_image) {
      const productCard = wrapper.closest('.grid-box') || wrapper.closest('.product-card');
      if (!productCard) return;

      const pictureElement = productCard.querySelector('.product-card__media picture');

      if (pictureElement) {
        const baseUrl = variantInfo.featured_image.split('?')[0];

        pictureElement.querySelectorAll('source').forEach(source => {
          const media = source.getAttribute('media');
          if (media && media.includes('1200px')) {
            source.srcset = `${baseUrl}?width=1200`;
          } else if (media && media.includes('768px')) {
            source.srcset = `${baseUrl}?width=1000`;
          } else if (media && media.includes('480px')) {
            source.srcset = `${baseUrl}?width=600`;
          }
        });

        const productImage = pictureElement.querySelector('img');
        if (productImage) {
          productImage.src = `${baseUrl}?width=1200`;
          productImage.srcset = `${baseUrl}?width=352 352w, ${baseUrl}?width=832 832w, ${baseUrl}?width=1200 1200w`;

          if (variantInfo.image_alt) {
            productImage.alt = variantInfo.image_alt;
          }
        }
      }
    }
  }

  getVariantsData(variantsList) {
    try {
      const dataAttr = variantsList.dataset.variantsInfo;
      return dataAttr ? JSON.parse(dataAttr) : null;
    } catch (e) {
      console.error('Error parsing variants data:', e);
      return null;
    }
  }

  handleToggle(button) {
    const wrapper = button.closest('.product-variants-wrapper');
    const variantsList = wrapper.querySelector('[data-variants-list]');
    const isExpanded = button.getAttribute('aria-expanded') === 'true';

    this.closeAllVariants();

    if (!isExpanded) {
      variantsList.classList.remove('hidden');
      button.setAttribute('aria-expanded', 'true');
      button.classList.add('active');
    }
  }

  handleVariantSelect(button) {
    const variantId = button.dataset.variantId;
    const form = button.closest('form');

    let variantInput = form.querySelector('input[name="id"]');

    if (!variantInput) {
      variantInput = document.createElement('input');
      variantInput.type = 'hidden';
      variantInput.name = 'id';
      form.appendChild(variantInput);
    }

    variantInput.value = variantId;

    const select = form.querySelector('.select_variant_option');
    if (select) {
      select.value = variantId;
    }

    this.closeAllVariants();
  }

  closeAllVariants() {
    document.querySelectorAll('[data-variants-toggle]').forEach(button => {
      const wrapper = button.closest('.product-variants-wrapper');
      const variantsList = wrapper.querySelector('[data-variants-list]');

      variantsList.classList.add('hidden');
      button.setAttribute('aria-expanded', 'false');
      button.classList.remove('active');
    });
  }
}

let productVariantsToggleInstance = null;

function initializeVariantsToggle() {
  if (!productVariantsToggleInstance) {
    productVariantsToggleInstance = new ProductVariantsToggle();
  } else if (productVariantsToggleInstance) {
    productVariantsToggleInstance.destroy();
    productVariantsToggleInstance = null;
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initializeVariantsToggle();
  });
} else {
  initializeVariantsToggle();
}
